// @flow
import {
    MIGRATION_STATUS_REQUEST,
    MIGRATION_STATUS_RESPONSE,
    START_MIGRATION_REQUEST,
    START_MIGRATION_RESPONSE,
    PROGRESS_INSTALL_STAGE,
    STAGE_START
} from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    // $FlowFixMe
    [MIGRATION_STATUS_REQUEST]: handleReduce(state => state.set('isLoadingStatus', true)),
    [MIGRATION_STATUS_RESPONSE]: handleReduce(
        (state, { payload: { status } }) =>
            // $FlowFixMe
            state
                .set('isLoadingStatus', false)
                .set('error', false)
                .set('status', fromJS(status)),
        (state, { payload: { code } }) =>
            // $FlowFixMe
            state
                .set('isLoadingStatus', false)
                .set('error', true)
                .set('errorCode', code)
    ),
    // $FlowFixMe
    [START_MIGRATION_REQUEST]: handleReduce(state => state.set('isStartingMigration', true)),
    [START_MIGRATION_RESPONSE]: handleReduce(
        // $FlowFixMe
        state => state.set('isStartingMigration', false).set('error', false),
        (state, { payload: { code } }) =>
            // $FlowFixMe
            state
                .set('isStartingMigration', false)
                .set('error', true)
                .set('errorCode', code)
    ),
    // $FlowFixMe
    [PROGRESS_INSTALL_STAGE]: handleReduce((state, { payload }) => state.set('installStage', payload))
};

export default handleActions(
    actionHandlers,
    fromJS({
        isLoadingStatus: false,
        isStartingMigration: false,
        status: fromJS({}),
        error: false,
        errorCode: '',
        installStage: STAGE_START
    })
);



// WEBPACK FOOTER //
// ./src/core/state/install-nano1-upgrade/index.js